import React from 'react';
const AccountDescription = () => {
  return (
    <div className="cart-step1" style={{ display: 'flex', padding: 15 }}>
      <div className="btn-cart-signin">
        Have an account? <br />
        Log In
      </div>
      <div className="btn-cart-signup">
        New To Lets Order Food? <br />
        Signup
      </div>
    </div>
  );
};

export default AccountDescription;
